import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  ConfigProvider,
  Input,
  Row,
  Typography,
  DatePicker,
  Col,
  Card,
  Table,
  Form,
  Spin,
  Select,
  Button,
  Statistic,
} from "antd";

// PROJECT IMPORTS
import { CSVLink } from "react-csv";
import appStatic from "../../../../config/appStatic";
import appLabel from "../../../../config/appLabel";
import definedApi from "../../../../services/definedApi";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import CustomButton from "../../../../components/custom/CustomButton";

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const columns = [
  {
    title: "ID",
    dataIndex: "id",
  },
  {
    title: "Branch",
    dataIndex: "branch",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },
  {
    title: "Transaction Date",
    dataIndex: "transactionDate",
    sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
  },
  {
    title: "Transaction Tag",
    dataIndex: "transactionTag",
  },
  {
    title: "Account",
    dataIndex: "account",
    sorter: (a, b) => a.account.localeCompare(b.account),
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
];

const SearchCurrentAccJournalEntry = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { RangePicker } = DatePicker;
  const { monthList } = appStatic;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [journalEntryList, setJournalEntryList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [officeData, setOfficeData] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    getOffice();
    getGlAccount();
    // DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    setIsLoading(false);
  }, []);

  function getOffice() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetOfficeList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(temp);
      }
    });
  }

  function getGlAccount() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetSpecificGLList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setAccountData(temp);
      }
    });
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  const onSubmit = (formValues) => {
    const originalDate = new Date(formValues.date[0]);
    const day = originalDate.getDate();
    const month = new Intl.DateTimeFormat("en", { month: "long" }).format(originalDate);
    const year = originalDate.getFullYear();
    const formattedDate = `${day} ${month} ${year}`;

    const originalDateOne = new Date(formValues.date[1]);
    const dayOne = originalDateOne.getDate();
    const monthOne = new Intl.DateTimeFormat("en", { month: "long" }).format(originalDateOne);
    const yearOne = originalDateOne.getFullYear();
    const formattedDateOne = `${dayOne} ${monthOne} ${yearOne}`;

    formValues.fromDate = formattedDate;
    formValues.toDate = formattedDateOne;

    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      session,
      sortOrder: "DESC",
      orderBy: "transactionDate",
    };

    setIsLoading(true);
    setShowSearch(true);
    BOM.FetchReqAction(
      body,
      `${definedApi.SearchJournalEntries}dateFormat=dd+MMMM+yyyy&fromDate=${encodeURIComponent(
        formValues.fromDate
      ).replace(/%20/g, "+")}&glAccountId=${
        formValues.glAccountId
      }&limit=14&locale=en&manualEntriesOnly=&officeId=${
        formValues.officeId
      }&offset=0&toDate=${encodeURIComponent(formValues.toDate).replace(/%20/g, "+")}`,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        } else {
          const objList = res.pageItems;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id ? element?.id : "-",
              branch: element?.officeName ? element?.officeName : "-",
              branchId: element?.officeId ? element?.officeId : "-",
              transactionDate: element?.transactionDate
                ? `${element?.transactionDate[2]} ${monthList[element?.transactionDate[1] - 1]} ${
                    element?.transactionDate[0]
                  }`
                : "-",
              transactionId: element?.transactionId ? element?.transactionId : "-",
              type: element?.glAccountType?.value ? element?.glAccountType?.value : "-",
              createdBy: element?.createdByUserName ? element?.createdByUserName : "-",
              account: element?.glAccountName
                ? `${element?.glAccountName} (${element?.glAccountCode})`
                : "-",
              debit: element?.entryType?.value?.toLowerCase() === "debit" ? element?.amount : "-",
              credit: element?.entryType?.value?.toLowerCase() === "credit" ? element?.amount : "-",
              transactionTag: element?.entryType?.value
                ? element?.entryType?.value === "DEBIT"
                  ? "Dr"
                  : element?.entryType?.value === "CREDIT"
                  ? "Cr"
                  : "-"
                : "-",
              amount: element?.amount ? (
                <Statistic
                  value={element?.amount}
                  precision={2}
                  valueStyle={{ fontSize: "16px" }}
                />
              ) : (
                "-"
              ),
              amountToUse: element?.amount ? element?.amount : 0,
            });
          });

          setJournalEntryList(tempArray);

          //keep the orginal data to use after gList is modified when change from autorise to disable
          setOriginalList(tempArray);

          //STOP LOAD
          setIsLoading(false);
        }
      }
    );
  };

  return (
    <Spin spinning={isLoading} size="large">
      <Form onFinish={onSubmit} layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
        <Card
          style={{
            marginBottom: "2%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          }}
          bordered
        >
          {/* <Text>RENDER TABLE LIST HERE</Text> */}
          <Row style={{ justifyContent: "space-between" }}>
            <Form.Item name="officeId" label={<Text strong>{appLabel.branch}</Text>}>
              <Select
                onChange={(e) => console.log(e)}
                options={officeData}
                showSearch
                placeholder={BOM.handlePlaceholderMsg(appLabel.branch)}
                style={{
                  width: 400,
                }}
              />
            </Form.Item>
            <Form.Item name="glAccountId" label={<Text strong>{appLabel.account}</Text>}>
              <Select
                options={accountData}
                placeholder={BOM.handlePlaceholderMsg(appLabel.account)}
                style={{
                  width: 400,
                }}
              />
            </Form.Item>
            <Form.Item name="date" label={<Text strong>{appLabel.dateRange}</Text>}>
              <RangePicker
                style={{
                  width: 400,
                }}
              />
            </Form.Item>
          </Row>
          {showSearch && (
            <Table
              rowSelection={{
                type: "radio",
                ...rowSelection,
                onChange: onSelectItemAction,
              }}
              columns={columns}
              dataSource={journalEntryList}
              bordered
              pagination={{
                position: "bottomCentre",
                pageSize: tableCount,
              }}
            />
          )}
        </Card>
        <Form.Item>
          <Row>
            <CustomButton
              content="Search"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              htmlType="submit"
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />
          </Row>
        </Form.Item>
      </Form>
    </Spin>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(SearchCurrentAccJournalEntry);
